import { FormControl, InputLabel, Select, MenuItem } from "@mui/material";
import React, { useState } from "react";
import FilterAltIcon from "@mui/icons-material/FilterAlt";
import Swal from "sweetalert2";
import { useEffect } from "react";
import PlantillaScreen from "../../helpers/PlantillaScreen";

export const MdlFiltrosScreen = ({ onCargarRecuperacion, recarga, estado }) => {
  const [openModal, setOpenModal] = useState(false);
  const [state, setState] = useState(() => {
    const savedState = localStorage.getItem("filtroEstado");
    return savedState
      ? JSON.parse(savedState)
      : {
        ejercicio:
          new Date().getFullYear() - (new Date().getMonth() === 1 ? 1 : 0),
        periodo: new Date().getMonth() === 1 ? 12 : new Date().getMonth() - 1,
        lineacredito: "C",
        vencimiento: "C",
        registrado: "C",
        domicilio: "C",
      };
  });
  var año = new Date().getFullYear();
  const handleChangeAño = (event) => {
    setState({ ...state, ejercicio: event.target.value });
  };
  const onOpenModal = () => {
    const container = document.getElementById("mdlFiltros-modal");
    if (!container) return;
    if (openModal) {
      container.style.display = "flex";
      setOpenModal(false);
    } else {
      container.style.display = "none";
      setOpenModal(true);
    }
  };

  const onCargar = () => {
    if (
      state.ejercicio === undefined ||
      state.ejercicio === null ||
      state.ejercicio === ""
    ) {
      Swal.fire(
        "BURO DE CREDITO",
        "Favor de indicar un ejercicio para el reporte",
        "warning"
      );
      return;
    }
    if (
      state.periodo === undefined ||
      state.periodo === null ||
      state.periodo === ""
    ) {
      Swal.fire(
        "BURO DE CREDITO",
        "Favor de indicar un periodo para el reporte",
        "warning"
      );
      return;
    }
    onCargarRecuperacion(state)
      .then(() => onOpenModal())
      .catch((error) => {
        Swal.fire("BURO DE CRÉDITO", JSON.stringify(error), "error");
      });
    localStorage.setItem("filtroEstado", JSON.stringify(state));
    estado(state);
  };

  useEffect(() => {
    if (recarga) {
      const container = document.getElementById("mdlFiltros-modal");
      if (!container) return;
      container.style.display = "none";
      setOpenModal(false);
    }
    const savedState = localStorage.getItem("filtroEstado");
    if (savedState) {
      onOpenModal();
    }
  }, [recarga]);

  return (
    <div className="mdlFiltros-buro">
      <div className="reporte-buro-credito-filtrado" onClick={onOpenModal}>
        <FilterAltIcon /> Filtrar
      </div>
      <div className="mdlFiltros-modal-buro" id="mdlFiltros-modal">
        <PlantillaScreen
          titulo={`FILTRO DE CARTERA`}
          className_main={1}
          className={"plantilla_buro_credito"}
        >
          <div className="mdlFiltros-modal-ejercicio">
            <FormControl>
              <InputLabel id="demo-simple-select-label-ejercicio">
                Ejercicio
              </InputLabel>
              <Select
                size="small"
                labelId="demo-simple-select-label-ejercicio"
                id="demo-simple-select-ejercicio"
                value={state.ejercicio}
                label="Ejercicio"
                onChange={handleChangeAño}
              >
                <MenuItem value={año - 1}>{año - 1}</MenuItem>
                <MenuItem value={año}>{año}</MenuItem>
                <MenuItem value={año + 1}>{año + 1}</MenuItem>
              </Select>
            </FormControl>

            <div className="mdlFiltros-modal-periodo">
              <FormControl>
                <InputLabel id="demo-simple-select-label-periodo">
                  Periodo
                </InputLabel>
                <Select
                  size="small"
                  labelId="demo-simple-select-label-periodo"
                  id="demo-simple-select-periodo"
                  value={state.periodo}
                  label="Periodo"
                  onChange={(event) =>
                    setState({ ...state, periodo: event.target.value })
                  }
                >
                  <MenuItem value={1}>Enero</MenuItem>
                  <MenuItem value={2}>Febrero</MenuItem>
                  <MenuItem value={3}>Marzo</MenuItem>
                  <MenuItem value={4}>Abril</MenuItem>
                  <MenuItem value={5}>Mayo</MenuItem>
                  <MenuItem value={6}>Junio</MenuItem>
                  <MenuItem value={7}>Julio</MenuItem>
                  <MenuItem value={8}>Agosto</MenuItem>
                  <MenuItem value={9}>Septiembre</MenuItem>
                  <MenuItem value={10}>Octubre</MenuItem>
                  <MenuItem value={11}>Noviembre</MenuItem>
                  <MenuItem value={12}>Diciembre</MenuItem>
                </Select>
              </FormControl>
            </div>
            <div className="mdlFiltros-modal-linea-credito">
              <FormControl>
                <InputLabel id="demo-simple-select-label-linea-credito">
                  Línea de Crédito
                </InputLabel>
                <Select
                  size="small"
                  labelId="demo-simple-select-label-linea-credito"
                  id="demo-simple-select-linea-credito"
                  value={state.lineacredito}
                  label="Linea de Credito"
                  onChange={(event) =>
                    setState({ ...state, lineacredito: event.target.value })
                  }
                >
                  <MenuItem value={"C"}>Consolidado</MenuItem>
                  <MenuItem value={"O"}>Operacion</MenuItem>
                  <MenuItem value={"R"}>Revolvente</MenuItem>
                </Select>
              </FormControl>
            </div>
            <div className="mdlFiltros-modal-vencimiento">
              <FormControl>
                <InputLabel id="demo-simple-select-label-vencimiento">
                  Vencimiento
                </InputLabel>
                <Select
                  size="small"
                  labelId="demo-simple-select-label-vencimiento"
                  id="demo-simple-select-vencimiento"
                  value={state.vencimiento}
                  label="Vencimiento"
                  onChange={(event) =>
                    setState({ ...state, vencimiento: event.target.value })
                  }
                >
                  <MenuItem value={"C"}>Consolidado</MenuItem>
                  <MenuItem value={"V"}>Vencidos</MenuItem>
                  <MenuItem value={"P"}>Por Vencer</MenuItem>
                </Select>
              </FormControl>
            </div>
            <div className="mdlFiltros-modal-registrado">
              <FormControl>
                <InputLabel id="demo-simple-select-label-registrado">
                  Registrado
                </InputLabel>
                <Select
                  size="small"
                  labelId="demo-simple-select-label-registrado"
                  id="demo-simple-select-registrado"
                  value={state.registrado}
                  label="Registrado"
                  onChange={(event) =>
                    setState({ ...state, registrado: event.target.value })
                  }
                >
                  <MenuItem value={"C"}>Consolidado</MenuItem>
                  <MenuItem value={"R"}>Registrado</MenuItem>
                  <MenuItem value={"N"}>No Registrado</MenuItem>
                </Select>
              </FormControl>
            </div>
            <div className="mdlFiltros-modal-domicilio">
              <FormControl>
                <InputLabel id="demo-simple-select-label-registrado">
                  Domicilio
                </InputLabel>
                <Select
                  size="small"
                  labelId="demo-simple-select-label-registrado"
                  id="demo-simple-select-registrado"
                  value={state.domicilio}
                  label="Domicilio"
                  onChange={(event) =>
                    setState({ ...state, domicilio: event.target.value })
                  }
                >
                  <MenuItem value={"C"}>Consolidado</MenuItem>
                  <MenuItem value={"R"}>Registrado</MenuItem>
                  <MenuItem value={"N"}>No Registrado</MenuItem>
                </Select>
              </FormControl>
            </div>
          </div>
          <div className="mdlFiltros-modal-acciones">
            <div
              className="mdlFiltros-modal-acciones-cancelar"
              onClick={onOpenModal}
            >
              Cancelar
            </div>
            <div
              className="mdlFiltros-modal-acciones-guardar"
              onClick={onCargar}
            >
              Cargar
            </div>
          </div>
        </PlantillaScreen>
      </div>
    </div>
  );
};
